module.exports = __webpack_public_path__ + "static/media/how-it-works-2.023d6a1c.png";